var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.878 5.41604L12.0322 2.4492C11.6822 1.22654 10.3452 0.50087 9.04318 0.827536L2.56118 2.46087C1.25918 2.78754 0.48685 4.0452 0.834517 5.26787L2.88785 12.4662C3.23785 13.6889 4.57485 14.4145 5.87685 14.0879L6.58502 13.9094M12.878 5.41604H8.91835C8.29951 5.41604 7.70602 5.66187 7.26844 6.09945C6.83085 6.53704 6.58502 7.13053 6.58502 7.74937V13.9094M12.878 5.41604H15.335C15.9539 5.41604 16.5473 5.66187 16.9849 6.09945C17.4225 6.53704 17.6684 7.13053 17.6684 7.74937V15.3327C17.6684 15.9515 17.4225 16.545 16.9849 16.9826C16.5473 17.4202 15.9539 17.666 15.335 17.666H8.91835C8.29951 17.666 7.70602 17.4202 7.26844 16.9826C6.83085 16.545 6.58502 15.9515 6.58502 15.3327V13.9094",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackServicesIcon);
export default __webpack_public_path__ + "static/media/black_services_icon.db04913b04a32426c6c952f10c30a8a0.svg";
export { ForwardRef as ReactComponent };